// extracted by mini-css-extract-plugin
module.exports = {"fade-to-black":"InducteesLandingWrapper_fade-to-black__tXNbv"};